import axios from "axios";
import get from "lodash/get";

import {
    askPasswordResetRequestFail,
    askPasswordResetRequestStart,
    askPasswordResetRequestSuccess,

    setNewPasswordRequestStart,
    setNewPasswordRequestSuccess,
    setNewPasswordRequestFail,

    registerRequestFail,
    registerRequestStart,
    registerRequestSuccess,

    sendAuthHSMRequestFail,
    sendAuthHSMRequestStart,
    sendAuthHSMRequestSuccess,

    sendCodeRequestFail,
    sendCodeRequestStart,
    sendCodeRequestSuccess,

    verifyCodeRequestFail,
    verifyCodeRequestStart,
    verifyCodeRequestSuccess,

    getMeRequestStart,
    getMeRequestSuccess,
    getMeRequestFail,

    retailCRMRegisterRequestFail,
    retailCRMRegisterRequestStart,
    retailCRMRegisterRequestSuccess,

    logInSetTokenAndUser,
    logInSetIsAuthenticated,
} from '../actions/Auth';
import {shopsSelectShop} from '../actions/Shops';
import {getBot} from './Dashboard';
import {eventsSetUserId} from "../Components/utils";


export const askPasswordReset = (email) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(askPasswordResetRequestStart(email));

        const data = {
            email,
        };

        instance.post('auth/ask_password_reset/', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(askPasswordResetRequestSuccess(email, response.data.result));
                } else {
                    dispatch(askPasswordResetRequestFail(response.data.errors));
                }
            },
            error => {
                dispatch(askPasswordResetRequestFail(get(error, 'response.data.errors')));
            },
        );
    }
};

export const setNewPassword = (password, token, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(setNewPasswordRequestStart(password, token));

        const data = {
            password,
            token,
        };

        instance.post('auth/password_reset/', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(setNewPasswordRequestSuccess(password, token, response.data.result));
                    callback && callback(response.data.result);
                } else {
                    dispatch(setNewPasswordRequestFail(response.data.errors));
                }
            },
            error => dispatch(setNewPasswordRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    }
};

export const sendAuthHSM = (phone, lang_code, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_SERVICE_AUTH_URL,
            
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(sendAuthHSMRequestStart(phone));

        const data = {
            phone,
            lang_code,
        };

        instance.post('auth_hsm', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(sendAuthHSMRequestSuccess(response.data.result));
                    callback && callback(response.data.result);
                } else {
                    dispatch(sendAuthHSMRequestFail(response.data.errors));
                }
            },
            error => dispatch(sendAuthHSMRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    }
};

export const sendCode = (phone_number, lang_code, redirectTo) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(sendCodeRequestStart(phone_number));

        const data = {
            phone_number,
            lang_code,
        };

        instance.post('auth/send_code/', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(sendCodeRequestSuccess(response.data.result));
                    if (redirectTo) {
                        window.location.href = redirectTo;
                    }
                } else {
                    dispatch(sendCodeRequestFail(response.data.errors));
                }
            },
            error => dispatch(sendCodeRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    }
};

export const verifyCode = (phone_number, code, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(verifyCodeRequestStart(phone_number, code));

        const data = {
            phone_number: phone_number,
            code: code,
        };

        instance.post('auth/verify_code/', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(verifyCodeRequestSuccess(response.data.result, phone_number, code));
                    callback && callback(response.data.result);
                } else {
                    dispatch(verifyCodeRequestFail(response.data.errors));
                }
            },
            error => dispatch(verifyCodeRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    }
};

export const register = (
    email,
    phone_number,
    code,
    password,
    passwordrep,
    check,
    referral_code,
    lang_code,
    callback,
) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(registerRequestStart(email, phone_number, code, password, passwordrep, check, referral_code));

        const data = {
            email,
            phone_number,
            code,
            password,
            passwordrep,
            check,
            ref: referral_code,
            lang_code,
        };

        instance.post('auth/register/', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(registerRequestSuccess(response.data.result.user.email));
                    callback && callback(response.data.result);
                } else {
                    dispatch(registerRequestFail(response.data.errors));
                }
            },
            error => dispatch(registerRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    };
};


export const retailCRMRegister = (
    module_name,
    phone,
    retailcrm_url,
    retailcrm_api_key,
    code,
    callback,
) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_SERVICE_AUTH_URL,
            
            headers: {
                'Content-Type': 'application/json',
            },
        });

        dispatch(retailCRMRegisterRequestStart(module_name, phone, retailcrm_url, retailcrm_api_key, code));

        const data = {
            module_name,
            phone,
            retailcrm_url,
            retailcrm_api_key,
            code,
        };

        instance.post('register_retailcrm', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(retailCRMRegisterRequestSuccess(response.data.result));
                    callback && callback(response.data.result);
                } else {
                    dispatch(retailCRMRegisterRequestFail(response.data.errors));
                }
            },
            error => dispatch(retailCRMRegisterRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    };
};

export const getMe = (authToken, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                Authorization: `Bearer  ${authToken}`,
                'Content-Type': 'application/json',
            },
        });

        dispatch(getMeRequestStart(authToken));

        instance.get('auth/get_me/').then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(getMeRequestSuccess(authToken, response.data.result.user));
                    eventsSetUserId(response.data.result.user.id);
                    callback && callback(response.data.result);
                } else {
                    dispatch(getMeRequestFail(response.data.errors));
                }
            },
            error => dispatch(getMeRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    };
};

export const authByLink = (authToken, shopId, botId, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                Authorization: `Bearer  ${authToken}`,
                'Content-Type': 'application/json',
            },
        });

        instance.get('auth/get_me/').then(
            ({data}) => {
                if (data.status === 'ok') {
                    dispatch(logInSetTokenAndUser(authToken, data.result.user));
                    eventsSetUserId(data.result.user.id);

                    instance.get(`shop/shops/${shopId}/`).then(
                       ({data}) => {
                            if (data.status === 'ok') {
                                dispatch(getBot(botId, shopId,
                                    () => {
                                        dispatch(logInSetIsAuthenticated(true));
                                        dispatch(shopsSelectShop(data.result));
                                    },
                                    error => {
                                        console.error(error.errors.detail);
                                        callback && callback();
                                    }
                                ));
                            } else {
                                console.error(data.errors.detail);
                                callback && callback();
                            }
                        },
                        error => {
                            console.error(error);
                            callback && callback();
                        },
                    );
                } else {
                    console.error(data.errors.detail);
                    callback && callback();
                }
            },
            error => {
                console.error(error);
                callback && callback();
            },
        );
    }
};
